import styled from 'styled-components'
import { inputStyles } from 'styles/input-styles'

export const InputStyled = styled.input`
  ${inputStyles};
`
